<template>
  <div class="hello">
     <h3>It looks like you've tried this quiz before.</h3><p></p>
        <div class="row">
         <div class="col-sm-4"></div>
          <div class="col-sm-4">
              <b-button block squared @click="resumeQuiz()" size="lg" variant="outline-success" >Continue Quiz</b-button><p></p>
              <b-button block squared @click="startOver()" variant="outline-dark" size="lg">Start Over</b-button>
 
          </div></div>
         <div class="col-sm-4"></div>
  </div>
</template>

<script>
export default {
  name: 'ContinueQuiz',
  props: {
    results: Object
      },
    data () {
        return {
        }
    },
    methods: {
        resumeQuiz: function () {
            this.$emit('resume')
        },
        startOver: function () {
            this.$emit('restart')
        }
    },
    created () {
        // this.getTitle()
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
